module.exports = __webpack_public_path__ + "static/img/cus_15_pre.0164c0e7.jpg";